import { cloneDeep } from "@/utils/object";

export default {
  beforeDestroy() {
    if(this.def.eventHandlers && Array.isArray(this.def.eventHandlers)){
      const EventHandlers = cloneDeep(this.def.eventHandlers)
      Array.from(EventHandlers).forEach((event)=>{
        const eventPreset = event.eventPreset?.name.split(".").pop().toLowerCase();
        if(eventPreset === "custom"){
          const eventName = event.customEventName
          const ref = this.def.id 

          // this.$eventBus.$off(`${ref}-${eventName}`)
        }     
      })
    }
  },




}